module.exports = __webpack_public_path__ + "img/Z.ff65794a.png";